import { BulkActionResultTabs } from "components/BulkActions/types";

export const getTabName = (tab: BulkActionResultTabs) => {
  switch (tab) {
    case BulkActionResultTabs.Completed:
      return "Completed";
    case BulkActionResultTabs.Failed:
      return "Failed";
    case BulkActionResultTabs.Pending:
    default:
      return "Pending";
  }
};
